// DashboardRoutes.tsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import Auth from "./components/routes/AuthRoute";
import PrivateRoute from "./components/routes/PrivateRoute";
import MainLayout from "./layout/MainLayout";
import Profile from "./pages/Profile";
import "react-quill/dist/quill.snow.css";
import ErrorPage from "./pages/ErrorPage";
import Dashboard from "./pages/Dashboard";
import Payments from "./pages/Payments";
import Settings from "./pages/Settings";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import AdminProjects from "./pages/admin/Projects";
import CreateProject from "./pages/admin/CreateProject";
import ProjectDetails from "./pages/admin/ProjectDetails";
import AdminUsers from "./pages/admin/Users";
import UserDetails from "./pages/admin/UserDetails";
import EditProject from "./pages/admin/EditProject";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminApplications from "./pages/admin/Applications";
import AdminTickets from "./pages/admin/AdminTickets";

export const DashboardRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Protected Dashboard */}
      <Route element={<PrivateRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/create-project" element={<CreateProject />} />

          <Route path="/admin/home" element={<AdminDashboard />} />
          <Route path="/admin/projects" element={<AdminProjects />} />
          <Route path="/admin/projects/create" element={<CreateProject />} />
          <Route
            path="/admin/projects/:projectId"
            element={<ProjectDetails />}
          />
          <Route
            path="/admin/projects/:projectId/edit"
            element={<EditProject />}
          />
          {/* <Route path="/admin/projects/:projectId/edit" element={<EditProject />} /> // You can create this similar to CreateProject */}
          <Route path="/admin/applications" element={<AdminApplications />} />
          <Route path="/admin/tickets" element={<AdminTickets />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/users/:userId" element={<UserDetails />} />
        </Route>
      </Route>

      {/* Public Auth Routes */}
      <Route path="/*" element={<Auth />} />

      {/* Global 404 - Standalone full page */}
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};
